module.exports = __webpack_public_path__ + "static/media/dropshipping.3dcd7e6c.jpg";